export const FEEDBACK_NOW_TIPS = [
  'Each question appears one at a time',
  'Tap an option for multiple-choice questions',
  'Use the microphone or type for open-ended answers',
  'When the green dot appears, speak your answer',
  'Review your response before clicking Next',
];

export const FEEDBACK_HOW_IT_WORKS_TIPS = FEEDBACK_NOW_TIPS;

export function getFeedbackVoiceStatusMessage({
  typingMode,
  speakingQuestion,
  voiceAlwaysOn,
  listening,
  supportsTts,
  supportsSpeech,
  usesVoiceInput = true,
}) {
  if (!usesVoiceInput) {
    return 'Choose one of the options below, then click Next.';
  }
  if (typingMode) {
    return 'Typing mode — microphone is paused. Type or edit your answer in the box below.';
  }
  if (speakingQuestion) {
    return 'Question is playing — wait for the green dot, then speak your answer.';
  }
  if (voiceAlwaysOn) {
    if (listening) {
      return 'Speak now — your answer appears below.';
    }
    if (supportsTts) {
      return 'Microphone will open after the question finishes.';
    }
    return 'Microphone is ready. Speak or tap Edit answer to type instead.';
  }
  if (supportsSpeech) {
    return 'Microphone paused — replay the question, resume the microphone, or edit your answer.';
  }
  if (supportsTts) {
    return 'Question audio will play automatically for each step.';
  }
  return 'Voice features are not supported in this browser.';
}
